const breadCrumb =
  "Lotação de Servidores - Manutenção de Informações do Servidor";

const routes = [
  {
    path: "/solicitacao-de-remocao-de-servidor",
    name: "solicitacao-de-remocao-de-servidor",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/SolicitacaoDeRemocaoDoServidor/SolicitacaoDeRemocaoDoServidorHome.vue"
      ),
  },
  {
    path: "/solicitacao-de-remocao-de-servidor/cadastro",
    name: "solicitacao-de-remocao-de-servidor-cadastro",
    meta: {
      allowedPermissions: ["servidor_remocao_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/SolicitacaoDeRemocaoDoServidor/SolicitacaoDeRemocaoDoServidorCadastro.vue"
      ),
  },
  {
    path: "/solicitacao-de-remocao-de-servidor/:solicatacoDeRemocaoDeServidorId/visualizar",
    name: "solicitacao-de-remocao-de-servidor-visualizar",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/SolicitacaoDeRemocaoDoServidor/SolicitacaoDeRemocaoDoServidorVisualizar.vue"
      ),
  },
  {
    path: "/solicitacao-de-remocao-de-servidor/:solicatacoDeRemocaoDeServidorId/editar",
    name: "solicitacao-de-remocao-de-servidor-editar",
    meta: {
      allowedPermissions: ["servidor_remocao_update"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/SolicitacaoDeRemocaoDoServidor/SolicitacaoDeRemocaoDoServidorEditar.vue"
      ),
  },
];

export default routes;
